'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperChooser = exports.ROUTES = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _nuiShell = require('@concur/nui-shell');

var _Errors = require('@concur/nui-shell/lib/components/Errors');

var _wwwWrapperCom = require('@concur/www-wrapper-com');

var _wwwWrapperCom2 = _interopRequireDefault(_wwwWrapperCom);

var _nuiIntl = require('@concur/nui-intl');

var _nuiIntl2 = _interopRequireDefault(_nuiIntl);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

var _listings = require('../listings');

var _listings2 = _interopRequireDefault(_listings);

var _listing = require('../listing');

var _listing2 = _interopRequireDefault(_listing);

var _SearchContainer = require('../search/SearchContainer');

var _SearchContainer2 = _interopRequireDefault(_SearchContainer);

var _TermsPage = require('../terms/TermsPage');

var _TermsPage2 = _interopRequireDefault(_TermsPage);

var _utils = require('../utils');

var _utilsModule = require('../utils/utilsModule');

var _HelpContainer = require('../help/HelpContainer');

var _HelpContainer2 = _interopRequireDefault(_HelpContainer);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _httpCode = require('@concur/nui-shell/lib/httpCode');

var httpCodes = _interopRequireWildcard(_httpCode);

var _NotFoundRedirect = require('../shared/NotFoundRedirect');

var _NotFoundRedirect2 = _interopRequireDefault(_NotFoundRedirect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ROUTES = exports.ROUTES = {
  US_PUBLIC: '/app-center',
  EU_PUBLIC: '/app-centre'
};

// silly little thing to let us use the in-product or public header and footer

var WrapperChooser = exports.WrapperChooser = function (_React$Component) {
  _inherits(WrapperChooser, _React$Component);

  function WrapperChooser() {
    _classCallCheck(this, WrapperChooser);

    return _possibleConstructorReturn(this, (WrapperChooser.__proto__ || Object.getPrototypeOf(WrapperChooser)).apply(this, arguments));
  }

  _createClass(WrapperChooser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var code = (0, _utils.getCountryCode)(this.props.meta.originalhost);
      this.props.setCountryCode(code);
    }
  }, {
    key: 'render',
    value: function render() {
      var usePublicWrapper = (0, _utils.isPublic)(this.props.location.pathname);
      if (usePublicWrapper) {
        var nuiLangToUse = (0, _utils.getNuiLanguage)(this.props.meta.originalhost);
        var publicLangToUse = (0, _utils.mapCountryToPublicLang)(this.props.meta.country || 'US');

        var localeData = (0, _nuiIntl.getLocaleData)(this.props);
        localeData.lang = nuiLangToUse;
        // eslint-disable-next-line import/no-dynamic-require, global-require
        var translations = window.NUI_TRANSLATIONS;
        return !this.props.meta.listingNotFound ? _react2.default.createElement(
          _wwwWrapperCom2.default,
          { lang: publicLangToUse },
          _react2.default.createElement(
            _nuiIntl2.default,
            { messages: translations, localeData: localeData },
            this.props.children
          )
        ) : _react2.default.createElement(_NotFoundRedirect2.default, null);
      }
      return _react2.default.createElement(
        _nuiShell.NuiPageContainer,
        null,
        this.props.meta.listingNotFound ? _react2.default.createElement(
          _Errors.ErrorPage,
          null,
          _react2.default.createElement(_Errors.NotFound, null)
        ) : this.props.children
      );
    }
  }]);

  return WrapperChooser;
}(_react2.default.Component);

WrapperChooser.propTypes = {
  location: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  meta: _propTypes2.default.shape({
    originalhost: _propTypes2.default.string,
    country: _propTypes2.default.string,
    listingFound: _propTypes2.default.bool
  }),
  setCountryCode: _propTypes2.default.func
};

function mapStateToProps(_ref) {
  var baseUrl = _ref.baseUrl,
      userPrefs = _ref.userPrefs,
      nuiPage = _ref.nuiPage,
      meta = _ref.meta;

  return { baseUrl: baseUrl, userPrefs: userPrefs, nuiPage: nuiPage, meta: meta };
}

var RRWrapperChooser = (0, _reactRedux.connect)(mapStateToProps, { setCountryCode: _utilsModule.setCountryCode })((0, _reactRouter.withRouter)(WrapperChooser));

var commonRoutes = [_react2.default.createElement(_reactRouter.IndexRoute, { component: _listings2.default, key: 'Listings' }), _react2.default.createElement(_reactRouter.Route, { path: 'listings/:id', component: _listing2.default, key: 'Listing' }), _react2.default.createElement(_reactRouter.Route, { path: 'listings/:id/:name', component: _listing2.default, key: 'ListingsName' }), _react2.default.createElement(_reactRouter.Redirect, { from: 'listing/:id/:name', to: 'listings/:id/:name', key: 'listingRedirect' }), _react2.default.createElement(_reactRouter.Route, { path: 'category/:category', component: _listings2.default, key: 'Category' }), _react2.default.createElement(_reactRouter.Route, { path: 'search/:term', component: _SearchContainer2.default, key: 'Search' }), _react2.default.createElement(_reactRouter.Route, { path: 'terms/:name', component: _TermsPage2.default, key: 'Terms' }), _react2.default.createElement(_reactRouter.Route, { path: 'help', component: _HelpContainer2.default, key: 'Help' })];

/* const public404 = (<Route
  path="*" onEnter={(nextState, replace) => {
    replace('/404');
  }}
/>); */

var commonWrapperRoute = _react2.default.createElement(
  _reactRouter.Route,
  { component: RRWrapperChooser },
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _App2.default },
    commonRoutes
  )
);

var public404 = _react2.default.createElement(_reactRouter.Route, { path: '*',
  status: httpCodes.NOT_FOUND,
  component: _NotFoundRedirect2.default
});

var publicRoute = _react2.default.createElement(
  'div',
  null,
  commonWrapperRoute,
  public404
);

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  null,
  _react2.default.createElement(
    _reactRouter.Route,
    { path: _config2.default.nui.baseUrl },
    commonWrapperRoute
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: ROUTES.US_PUBLIC, isAnonymous: true },
    publicRoute
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: ROUTES.EU_PUBLIC, isAnonymous: true },
    publicRoute
  )
);


//////////////////
// WEBPACK FOOTER
// ./lib/app/routes.js
// module id = 555
// module chunks = 0